import { CustomBox } from "components";
import { TrialSubscriptionIcon } from "pages/internal-dashboard/icons";
import { getGrowthTrends } from "../../helpers";

export function UsersWithTrial({ data, isLoading }: any) {
  const { today, thisWeek, thisMonth, thisYear, total } = data || {};

  const growthTrends = getGrowthTrends(data);

  return (
    <CustomBox
      loading={isLoading}
      color="#78BA2C"
      title="Users with trial subscriptions"
      userCount={total || 0}
      boxData={{
        label: "Trial Subscribers",
        description:
          "Users currently exploring the platform with trial access.",
        todayCount: today || 0,
        weekCount: thisWeek || 0,
        monthCount: thisMonth || 0,
        yearCount: thisYear || 0,
        icon: TrialSubscriptionIcon,
      }}
      percentages={growthTrends}
    />
  );
}
